import AlvaLogo from "../../../assets/alva/img/alva-logo.svg";
import DefaultLogo from "../../../assets/default/img/logo-opti-node.png";
import SecondaryDefaultLogo from "../../../assets/default/img/logo.png";
import SecondarySmarendoLogo from "../../../assets/roedl/img/logo-white-small.png";
import SmarendoLogo from "../../../assets/roedl/img/logo.svg";
import WavelrLogo from "../../../assets/wavelr/img/wavelr-logo.svg";
import { SiteName } from "../../../utils/enums";

export function getSiteLogo(siteName: SiteName, useSecondaryImage: boolean) {
  if (siteName === SiteName.Smarendo) {
    if (useSecondaryImage) {
      return SecondarySmarendoLogo;
    }
    return SmarendoLogo;
  } else if (siteName === SiteName.Alva) {
    return AlvaLogo;
  } else if (siteName === SiteName.Wavelr) {
    return WavelrLogo;
  }

  if (useSecondaryImage) {
    return SecondaryDefaultLogo;
  }

  return DefaultLogo;
}
